module.exports = __webpack_public_path__ + "img/cyril_ocular.3ed0fada.jpg";